import { Component } from '@angular/core';

import { KpiExportComponent } from '../components/kpi-export/kpi-export.component';

@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrls: ['./analytics.component.scss'],
    standalone: true,
    imports: [KpiExportComponent]
})
export class AnalyticsComponent {}
